import { Injectable } from '@angular/core'
import { PageGuard } from '@app/guards/page.guard'
import { getState } from '@app/srv/store.service'
import { GuideId, HardwareId } from '@naturalcycles/shared'

@Injectable({
  providedIn: 'root',
})
export class B1MeasuringGuidePageGuard extends PageGuard {
  className = 'B1MeasuringGuidePageGuard'

  get requirements(): boolean[] {
    const { account, guides } = getState()

    const requirements = [
      guides.items.some(guide => guide.id === GuideId.B1),
      account.hwId === HardwareId.B1,
    ]

    return requirements
  }
}
